import script from "./RegistrationCard.vue?vue&type=script&setup=true&lang=js"
export * from "./RegistrationCard.vue?vue&type=script&setup=true&lang=js"

import "./RegistrationCard.vue?vue&type=style&index=0&id=589c1f3e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-589c1f3e"]])

export default __exports__